// extracted by mini-css-extract-plugin
export var attachmentContainer = "_mk-0";
export var fileList = "_mk-2";
export var removeFileButton = "_mk-1";